import autobind from 'autobind-decorator';
import { injectable } from 'inversify';
import { observable, computed } from 'mobx';

import { container } from 'src/inversify.config';
import { $data } from 'src/core/services/data/JayDataContext';

@injectable()
export class DataLocalService<T> implements DataSet<T> {
	private isArchived: boolean = false;
	private query: () => T[];

	constructor(private source: T[], pageSize?: number) {
		this._count = source.length;
		this.query = null;
		if (pageSize != null) {
			this.pageSize = pageSize;
		}
	}

	@computed
	get items(): T[] {
		const startIndex = (Math.max(this.currentPage, 1) - 1) * this.pageSize;
		return this.source.slice(startIndex, startIndex + this.pageSize);
	}

	@computed
	get item(): T {
		if (this.items.length == 0) {
			return null;
		}

		return this.items[0];
	}

	searchKeywords: string;
	applyFilters: (query: any) => any;

	@autobind
	addSorting<K extends keyof T>(key: K, dir: 'asc' | 'desc', isDefault?: boolean) {

	}

	@autobind
	removeSorting<K extends keyof T>(key: K) {

	}

	@autobind
	hasSorting<K extends keyof T>(key: K) {
		return false;
	}

	@autobind
	addFilter<K extends keyof T>(key: K, operator: FilterOperator, value: any, filtertype?: string) {
	}
	public removeAllFilter() {

	}
	removeFilter<K extends keyof T>(key: K, filtertype?: string): void {
	}

	hasFilter<K extends keyof T>(key: K, hasValue = false, filtertype?: string): boolean {
		return false;
	}

	setQuery(query: () => T[]): void {
		this.query = query;
	}

	load(query?: (entitySet: $data.EntitySet<any, any>) => $data.Queryable<T>): Promise<T[]> {
		if (this.query != null) {
			const items = this.query();
			this.source = items;
			this._count = items.length;
		}

		return Promise.resolve(this.items);
	}

	reload = (): Promise<T[]> => {
		return this.load();
	};

	@autobind
	public toggleArchive() {
		this.isArchived = !this.isArchived;
		return this.reload();
	}

	// Paginator
	@observable
	private _count: number = 1;

	@computed
	public get count() {
		return this._count;
	}

	@observable
	private _pageSize: number = 1000;

	@computed
	public get pageSize() {
		return this._pageSize;
	};
	public set pageSize(value: number) {
		this._pageSize = value;
		this._currentPage = 1;
	}

	@observable
	private _currentPage: number = 1;

	@computed
	public get currentPage() {
		return this.count == 0 ? 0 : this._currentPage;
	}

	public set currentPage(value: number) {
		if (value < 1)
			value = this.count > 0 ? 1 : 0;
		if (value > this.totalPages)
			value = this.totalPages;
		this._currentPage = value;
	}

	@computed
	public get totalPages() {
		return Math.ceil(this.count / this.pageSize);
	};

	@autobind
	public nextPage() {
		return new Promise<T[]>((resolve, reject) => {
			this.currentPage++;
			this.reload().then(resolve).catch(reject);
		});
	}

	@autobind
	public previousPage() {
		return new Promise<T[]>((resolve, reject) => {
			this.currentPage--;
			this.reload().then(resolve).catch(reject);
		});
	}

	firstPage = (): Promise<T[]> => {
		this.currentPage = 1;
		return this.reload();
	}

	@autobind
	public lastPage() {
		return new Promise<T[]>((resolve, reject) => {
			this.currentPage = Math.ceil(this.count / this.pageSize);
			this.reload().then(resolve).catch(reject);
		});
	}

	// CRUD
	public isDirty = false;

	public isModelDirty = false;

	find(predicate: (entity: T) => boolean, params?: {}): Promise<T> {
		return new Promise((resolve, reject) => resolve(this.source.find(predicate)));
	}
	createSync(entityConstructor: () => T): T {

		let entity = entityConstructor();
		this.source.push(entity);
		this.pageSize = this.pageSize + 1;
		this.pageSize = this.pageSize - 1;
		this._count = this.source.length;
		this.isDirty = true;
		return this.source[this.source.length - 1]

	}
	create(entityConstructor: () => T): Promise<T> {
		return new Promise((resolve, reject) => {
			let item = this.createSync(entityConstructor);
			resolve(item);
		});
	}

	delete(items: T[]): Promise<number> {
		return new Promise((resolve, reject) => {
			for (const i of items) {
				const index = this.source.findIndex(e => e == i);
				if (index > -1) {
					(this.source as any[]).splice(index, 1);
				}
			}
			this.pageSize = this.pageSize + 1;
			this.pageSize = this.pageSize - 1;
			this._count = this.source.length;
			this.isDirty = true;
			resolve(0);
		});
	}

	restore(items: T[]): Promise<number> {
		return new Promise((resolve, reject) => {
			resolve(0);
		});
	}

	save(): Promise<number> {
		return null;
	}
}



// WEBPACK FOOTER //
// ./src/core/services/data-local.service.ts